module.exports = __webpack_public_path__ + "media/mens-health-0ff58cd4.svg";